module.exports = __webpack_public_path__ + "img/mail_sent.1b756918.png";